import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusItemProps } from "apis/status";
import { PaginationProps } from "utils/types/API";

export interface StatusState {
    loading: boolean;
    list: {
        data: StatusItemProps[];
        options: StatusItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: StatusItemProps;
    };
}

const initialState: StatusState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: StatusItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: StatusItemProps;
}
export const statusSlice = createSlice({
    name: "status",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = statusSlice.actions;
export default statusSlice.reducer;
